export default {
	CATEGORY: 'category',
	PUBLISH_STATUS: 'publish_status',
	APPROVAL_STATUS: 'approval_status',
	APPROVAL_METHOD: 'approval_method',
	RENTAL_STATUS: 'rental_status',
};
